import type { Confidence, TriageStatus } from "@/hooks/use-baseline";
import { cn } from "@/lib/utils";
import { TRIAGE_BADGE } from "./triage-tones";

export function StatusBadge({ status, className }: { status: TriageStatus; className?: string }) {
  const meta = TRIAGE_BADGE[status];
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium",
        meta.cls,
        className,
      )}
    >
      {meta.label}
    </span>
  );
}

export function ConfidenceDots({
  confidence,
  className,
}: {
  confidence: Confidence;
  className?: string;
}) {
  const filled = confidence === "high" ? 3 : confidence === "medium" ? 2 : 1;
  return (
    <span
      role="img"
      aria-label={`Confidence: ${confidence}`}
      className={cn("inline-flex items-center gap-0.5", className)}
      title={`Confidence: ${confidence}`}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className={cn(
            "h-1.5 w-1.5 rounded-full",
            i < filled ? "bg-foreground/70" : "bg-foreground/15",
          )}
        />
      ))}
    </span>
  );
}
